import { render, staticRenderFns } from "./Dokumente.vue?vue&type=template&id=c3ce1832&scoped=true&"
import script from "./Dokumente.vue?vue&type=script&lang=js&"
export * from "./Dokumente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3ce1832",
  null
  
)

export default component.exports